import {useSelector} from 'react-redux'
import {getSrpEntryFilters} from 'modules/accommodation/selectors'
import {isVioOfferOrBundleSelected} from 'modules/accommodation/utils'
import {SearchUrlParams} from 'modules/search/types'

import {useRouterProvider} from '@vio/core/src/_web/router/context/RouterContext'

/**
 * Builds the query string for the Search Results Page from the current Accommodation Page URL
 * @param hotelSlug - The hotel slug in the URL
 * @returns SearchUrlParams
 */
export const useSrpQueryString = (hotelSlug: string): SearchUrlParams => {
  const {getQueryParams} = useRouterProvider()
  const srpEntryFilters = useSelector(getSrpEntryFilters)
  const {
    checkIn,
    checkOut,
    rooms,
    optimizeRooms,
    userSearch,
    freeCancellation,
    profile,
    utm_source
  }: SearchUrlParams = getQueryParams()

  // Room filters are synced to the AP url for top offers. For hotel clickers they
  // must not change the SRP they return to, so use the value the AP was opened with
  const srpFreeCancellation =
    srpEntryFilters && !isVioOfferOrBundleSelected()
      ? srpEntryFilters.freeCancellation
      : freeCancellation

  return {
    hotelId: hotelSlug,
    checkIn,
    checkOut,
    rooms,
    optimizeRooms,
    userSearch,
    freeCancellation: srpFreeCancellation,
    profile,
    utm_source
  }
}
